import { Component, computed, effect, ElementRef, inject, signal, viewChild, ViewChild } from '@angular/core';
import { ProgressService } from '../../lib/progress.service';
import { Product } from '@shared';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-booking-tokens',
  imports: [CurrencyPipe, FormsModule, RouterLink],
  templateUrl: './booking-tokens.component.html',
  styleUrl: './booking-tokens.component.css',
})
export class BookingTokensComponent {
  public progressService = inject(ProgressService);
  private changes = signal(0);
  public selectedTokenSum = computed<number>(
    () =>
      (this.progressService.selectedAdditionalProducts()
        ?.map((product) => {
          console.log(
            'Amount Price. Cum',
            +(product.pivot!.amount || 0),
            +product.price + +(product.bediengeld || 0),
          );
          return (
            +(product.pivot!.amount || 0) *
            (+product.price + +(product.bediengeld || 0))
          );
        })
        .reduce((prev, cur) => prev + cur, 0) || 0) +
      this.changes() -
      this.changes(),
  );

  setAmount(product: Product, value: number | Event) {
    console.log('setAmount', value, product);
    let valuetoSet = 0;
    if (value instanceof Event) {
      valuetoSet = +(value.target as HTMLInputElement).value;
    } else {
      valuetoSet = +value;
    }

    product.pivot!.amount = Math.round(Math.min(
      Math.max(valuetoSet, 0),
      this.progressService.selectedPersons()! * 10,
    ));
    this.changes.set(valuetoSet);
  }
  increaseAmount(product: Product) {
    console.log('increaseAmount');
    this.setAmount(product, (product.pivot!.amount || 0) + 1);
  }
  decreaeseAmount(product: Product) {
    console.log('decreaeseAmount');
    this.setAmount(product, (product.pivot!.amount || 0) - 1);
  }

  advanceButton = viewChild<ElementRef>('advandeButton');

  constructor() {
    effect(() => {
      if(this.progressService.selectedAdditionalProducts() && this.progressService.selectedAdditionalProducts()?.length == 0) {
        this.advanceButton()?.nativeElement.click();
      }
    });
  }
}
